import {useNavigate} from "react-router-dom";
import {useAuth} from "react-oidc-context";
import {fetchUserInfo, setUserInfo} from "../../services/UserInfoService";
import {FnPUser} from "../../model/FnPUser";
import {
  ROLE_CA_DATA_MANAGER,
  ROLE_CA_END_USER,
  ROLE_ESA_END_USER, ROLE_FUNC_ADMIN
} from "../../constants/EiopaFnPConstants";
import {useEffect} from "react";
import {useMaintenance, isMaintenanceActive} from "../../context/MaintenanceContext";

function Callback() {

  let navigate = useNavigate();
  const auth = useAuth();
  const { isMaintenanceMode } = useMaintenance();
  useEffect(() => {
    const handleCallback = async () => {
      try {

        if (auth.error) {
          console.error('OIDC Error:', auth.error);
        }

        if (auth.isLoading) {
          return <div>Loading...</div>;
        }
        if (auth.user && auth.user.id_token) {
            await fetchUserInfo(auth.user.id_token).then((userInfo:FnPUser | undefined) => {
              _navigateUser(userInfo);
            });
        }
      } catch (error) {
          console.error('Login callback error: ', error);
          navigate("/");
      }
    };

    handleCallback();
  }, [auth.user, auth.error]);

  function _navigateUser(userInfo: FnPUser | undefined) {
    if(!userInfo || userInfo.roles.length === 0){
      // Guard against racing with async React state update for maintenance mode:
      // use the synchronous latch; if maintenance is active, do not navigate.
      if (!isMaintenanceMode && !isMaintenanceActive()) {
        navigate("/unauthorized");
      }
      return null;
    }
    setUserInfo(userInfo);
    // Redirect the user to the main component or any desired route
    if(userInfo.roles.includes(ROLE_CA_END_USER) || userInfo.roles.includes(ROLE_ESA_END_USER)) {
      navigate("/view-requests");
      return null;
    }

    if(userInfo.roles.includes(ROLE_CA_DATA_MANAGER)) {
      navigate("/manage-system-data/poi-list");
      return null;
    }

    if(userInfo.roles.includes(ROLE_FUNC_ADMIN)) {
      navigate("/admin/eu-sec-leg-bases");
      return null;
    }
  }

  return (
      <div>
        <p>Logging in...</p>
      </div>
  );
}

export default Callback;
